import { Component, input } from '@angular/core';

type IncidentStatus = 'has-incident' | 'no-incident' | 'hidden';

@Component({
  selector: 'app-pan-incident-status',
  templateUrl: './pan-incident-status.component.html',
  styleUrl: './pan-incident-status.component.scss',
  standalone: false,
})
export class PanIncidentStatusComponent {
  public status = input.required<IncidentStatus>();
}
